import React, { useState } from 'react';
import {
    DollarSign,
    Calendar,
    FileText,
    Award,
    Briefcase,
    Clock
} from 'lucide-react';

const SalaryDemo = () => {
    // 模擬薪資計算數據
    const [salaryData, setSalaryData] = useState({
        baseSalary: 45000,
        overtimePay: 2500,
        bonus: 3000,
        deductions: {
            healthInsurance: 1500,
            laborInsurance: 1200,
            tax: 2000
        },
        attendanceBonus: 1500
    });

    // 薪資項目
    const salaryItems = [
        {
            name: '基本工資',
            amount: salaryData.baseSalary,
            type: 'income',
            icon: <Briefcase />
        },
        {
            name: '加班費',
            amount: salaryData.overtimePay,
            type: 'income',
            icon: <Clock />
        },
        {
            name: '績效獎金',
            amount: salaryData.bonus,
            type: 'income',
            icon: <Award />
        },
        {
            name: '勤務獎金',
            amount: salaryData.attendanceBonus,
            type: 'income',
            icon: <Calendar />
        },
        {
            name: '健保扣款',
            amount: salaryData.deductions.healthInsurance,
            type: 'deduction',
            icon: <FileText />
        },
        {
            name: '勞保扣款',
            amount: salaryData.deductions.laborInsurance,
            type: 'deduction',
            icon: <FileText />
        },
        {
            name: '所得稅',
            amount: salaryData.deductions.tax,
            type: 'deduction',
            icon: <DollarSign />
        }
    ];

    // 計算總收入與總扣款
    const totalIncome = salaryItems
        .filter(item => item.type === 'income')
        .reduce((sum, item) => sum + item.amount, 0);

    const totalDeductions = salaryItems
        .filter(item => item.type === 'deduction')
        .reduce((sum, item) => sum + item.amount, 0);

    const netSalary = totalIncome - totalDeductions;

    return (
        <div className="p-8">
            <div className="grid md:grid-cols-2 gap-8">
                {/* 左側：薪資明細 */}
                <div>
                    <h2 className="text-2xl font-bold mb-4 flex items-center">
                        <DollarSign className="mr-2 text-primary-600" />
                        王小明 - 本月薪資明細
                    </h2>

                    <div className="space-y-4">
                        {salaryItems.map((item) => (
                            <div
                                key={item.name}
                                className={`flex justify-between items-center p-4 rounded-lg ${item.type === 'income'
                                        ? 'bg-green-50 border-2 border-green-200'
                                        : 'bg-red-50 border-2 border-red-200'
                                    }`}
                            >
                                <div className="flex items-center">
                                    {React.cloneElement(item.icon, {
                                        className: `mr-3 ${item.type === 'income'
                                                ? 'text-green-600'
                                                : 'text-red-600'
                                            }`
                                    })}
                                    <span>{item.name}</span>
                                </div>
                                <span className={`font-semibold ${item.type === 'income'
                                        ? 'text-green-700'
                                        : 'text-red-700'
                                    }`}>
                                    {item.type === 'income' ? '+' : '-'}NT${item.amount}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 右側：薪資總結 */}
                <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4">薪資概況</h3>

                    <div className="space-y-4">
                        <div className="flex justify-between border-b pb-2">
                            <span>總收入</span>
                            <span className="font-semibold text-green-700">NT${totalIncome}</span>
                        </div>

                        <div className="flex justify-between border-b pb-2">
                            <span>總扣款</span>
                            <span className="font-semibold text-red-700">NT${totalDeductions}</span>
                        </div>

                        <div className="flex justify-between pt-2">
                            <span className="font-bold">實發薪資</span>
                            <span className="text-2xl font-bold text-primary-600">NT${netSalary}</span>
                        </div>
                    </div>

                    <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                        <h4 className="font-semibold mb-2 flex items-center">
                            <Award className="mr-2 text-yellow-500" />
                            績效獎金說明
                        </h4>
                        <p className="text-sm text-gray-600">
                            本月績效獎金NT$3,000，根據個人KPI達成率 (85%) 核算。獎金由出勤情況、工作質量與專案完成度綜合評定。
                        </p>
                    </div>
                </div>
            </div>

            {/* 底部操作區域 */}
            <div className="mt-8 flex justify-between items-center bg-white p-6 rounded-lg shadow-md">
                <div>
                    <h4 className="font-semibold">薪資單下載與查看</h4>
                    <p className="text-sm text-gray-600">
                        您可以下載或線上查看詳細的薪資明細
                    </p>
                </div>
                <div className="flex space-x-4">
                    <button className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors">
                        下載PDF
                    </button>
                    <button className="border border-primary-600 text-primary-600 px-4 py-2 rounded-lg hover:bg-primary-50 transition-colors">
                        線上明細
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalaryDemo;